import { Inject, Injectable } from '@angular/core';

const oneLine = (strings: TemplateStringsArray, ...values: unknown[]) =>
  String.raw({ raw: strings }, ...values)
    .split('\n')
    .map((s) => s.trim())
    .filter(Boolean)
    .join(' ');
import { ENV, IEnvironment } from 'env/config';

import { Service } from '../entity/index';
import { DataService } from '../http/dataService';
import { VendorSalesRep } from '../models/vendorSalesRep.model';
import { Repository } from './repository';

//TODO this service should be replace by the other 2 in d2c-user.ts
@Service({
  model: VendorSalesRep,
})
@Injectable({ providedIn: 'root' })
export class RepRosterService extends Repository<VendorSalesRep> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: env.api.backend.reproster.endpoint as string,
    });
  }

  static getVendorDropdownQuery(queryParams?) {
    let query = `SELECT Id, Name FROM Vendor_Group__c`;

    if (queryParams && queryParams.vendorAccountName) {
      query = `${query} WHERE Vendor__c = '${queryParams.vendorAccountName}'`;
    }

    // single ID
    if (queryParams && queryParams.id) {
      const queryById = `Name = '${queryParams.id}'`;
      query = this.checkWhereKeyword(queryById, query);
    }

    // list of IDs
    if (queryParams && queryParams.ids) {
      const queryById = `Name IN (${queryParams.ids})`;
      query = this.checkWhereKeyword(queryById, query);
    }

    return query;
  }

  static getVendorGroupQuery(queryParams?, isCount = false) {
    let query = !isCount
      ? oneLine`SELECT
        Id,
        Name,
        Vendor__c,
        Rep_Count__c,
        CreatedDate,
        LastModifiedDate,
        Owner.Name,
        CreatedBy.Name,
        LastModifiedBy.Name
      FROM Vendor_Group__c`
      : oneLine`SELECT COUNT() FROM Vendor_Group__c`;

    if (queryParams && queryParams.vendorAccountName) {
      query = `${query} WHERE Vendor__c = '${queryParams.vendorAccountName}'`;
    }

    if (queryParams && queryParams.id) {
      const queryById = `Id = '${queryParams.id}'`;
      query = this.checkWhereKeyword(queryById, query);
    }

    if (!isCount && queryParams && queryParams.limit) {
      query = `${query} LIMIT ${queryParams.limit}`;
    }

    if (
      !isCount &&
      queryParams &&
      queryParams.page !== undefined &&
      queryParams.page !== 0
    ) {
      query = `${query} OFFSET ${queryParams.page * queryParams.limit}`;
    }

    return query;
  }

  private static checkWhereKeyword(key: string, query: string): string {
    return (query = query.includes('WHERE ')
      ? `${query} AND ${key}`
      : `${query} WHERE ${key}`);
  }

  createFromDTO(result) {
    return result;
  }
}
